import { useEffect, useState } from "react";
import AgentStatistic from "components/view/agent_statistic";
import report_wis_loss_member_for_ranking, {
  ReportWithLossMemberForRankingResponse,
} from "lib/worker/api/report_wis_loss_member_for_ranking";
import Spinner from "./loader";
import DateIcon from "./date_to_date_icon";

interface Props {
  isLogin: boolean;
}

export default function HistoryAgent(props: Props) {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [transaction, settransaction] = useState<
    ReportWithLossMemberForRankingResponse[]
  >([]);
  const [isloading, setloading] = useState<boolean>(false);

  const assignFromDate = (e: { target: { value: any } }) => {
    setFromDate(e.target.value);
  };

  useEffect(() => {
    const startdate = new Date();
    const enddate = new Date();
    if (props.isLogin) {
      reloadReport(startdate.toISOString(), enddate.toISOString());
    }
  }, []);

  const reloadReport = (start: string, end: string) => {
    setloading(true);
    report_wis_loss_member_for_ranking({ start: start, end: end })
      .then(settransaction)
      .finally(() => {
        setloading(false);
      });
  };

  return (
    <>
      <AgentStatistic transaction={transaction}></AgentStatistic>
      <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="form-group" style={{ width: 150, marginRight: 5 }}>
          วันที่ <DateIcon></DateIcon>
          <input
            type="date"
            name="from"
            id="startdate"
            value={fromDate}
            onChange={assignFromDate}
            className="datepicker"
            style={{ width: "150px" }}
          />
        </div>
        <div className="form-group" style={{ width: 150, marginRight: 10 }}>
          ถึงวันที่
          <input
            type="date"
            name="to"
            id="enddate"
            value={toDate}
            placeholder="Select Date"
            onChange={(e) => setToDate(e.target.value)}
            className="datepicker"
            style={{ width: "150px" }}
          />
        </div>
        <button
          disabled={isloading}
          className="btn btn-purple-submit"
          style={{
            width: 60,
            marginLeft: 10,
            padding: 0,
            height: 30,
            marginTop: 24,
          }}
          onClick={() => {
            reloadReport(fromDate, toDate);
          }}
        >
          {isloading ? <Spinner></Spinner> : "ยืนยัน"}
        </button>
      </div>
      <div className="card-add-bg">
        <div className="card-table">
          <div
            className="card-add-headings"
            style={{ paddingTop: 10, paddingBottom: 10, paddingLeft: 5 }}
          >
            <span className="card-add-heading text-left">ผู้เล่น</span>
            <span className="card-add-heading text-center">เทิร์น</span>
            <span className="card-add-heading text-center">รอบ</span>
            <span className="card-add-heading text-center">ชนะ/แพ้</span>
            <span className="card-add-heading text-center">คอมมิชชั่น</span>
          </div>
          <div className="line-span" style={{ marginTop: 0 }}></div>
          <div className="row wrapper">
            {transaction.map((el, i) => {
              return (
                <div
                  key={i}
                  className="card-add"
                  style={{
                    paddingTop: 5,
                    paddingBottom: 0,
                  }}
                >
                  <div className="font-card-add text-left">{el.Username}</div>
                  <div className="font-card-add text-center">
                    {el.Turnover?.format(2, 0)}
                  </div>
                  <div className="font-card-add">
                    <label>
                      <div> {el.BetCount?.format(0, 0)}</div>
                    </label>
                  </div>
                  <div
                    style={{ color: (el.Bet ?? 0) < 0 ? "red" : "white" }}
                    className="font-card-add"
                  >
                    {el.Bet?.format(2, 0)}
                  </div>
                  <div
                    style={{ color: (el.Com ?? 0) < 0 ? "red" : "white" }}
                    className="font-card-add text-center"
                  >
                    {el.Com?.format(2, 0)}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
